export default "__VITE_ASSET__5y9zBusG__"